import types from '../mutation-types';
import Vue from 'vue';
import campaignsContactList from '../../api/campaignsContactList';

export const state = {
  records: [],
  tab: null,
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
    isEditing: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getTab(_state) {
    return _state.tab;
  },
  getList(_state){
    return _state.records;
  }
};

export const actions = {
    get: async function getContactsList({ commit }) {
        commit(types.SET_LIST_CONTACTS_UI_FLAG, { isFetching: true });
        commit(types.CLEAN_LIST_CONTACTS);
        try {
        const { data } = await campaignsContactList.getAll();

        commit(types.SET_LIST_CONTACTS, data);
        } catch (error) {
        throw new Error(error);
        } finally {
        commit(types.SET_LIST_CONTACTS_UI_FLAG, { isFetching: false });
        }
    },
    setTab({ commit }, { tab }) {
      commit(types.SET_CAMPAIGNS_TAB, tab);
    },

    async delete({ commit }, listId) {
      commit(types.SET_LIST_CONTACTS_UI_FLAG, { isDeleting: true });
      try {
        await campaignsContactList.deleteList(listId);
        commit(types.DELETE_LIST_CONTACTS, listId);
      } catch (error) {
        throw new Error(error);
      } finally {
        commit(types.SET_LIST_CONTACTS_UI_FLAG, { isDeleting: false });
      }
    },

    async getById(_, listId) {
      try {
        const { data } = await campaignsContactList.getById(listId);
        return data
      } catch (error) {
        throw new Error(error);
      }
    },

    async create({ commit }, payload) {
      commit(types.SET_LIST_CONTACTS_UI_FLAG, { isCreating: true });
      try {
        const { data } = await campaignsContactList.createList(payload);
        commit(types.ADD_LIST_CONTACTS, data);
      } catch (error) {
        throw new Error(error);
      } finally {
        commit(types.SET_LIST_CONTACTS_UI_FLAG, { isCreating: false });
      }
    },


  async update({ commit }, payload) {
    commit(types.SET_LIST_CONTACTS_UI_FLAG, { isEditing: true });
    try {
      const { data } = await campaignsContactList.update(payload);
      commit(types.EDIT_LIST_CONTACTS, data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_LIST_CONTACTS_UI_FLAG, { isEditing: false });
    }
  },

  getAllContacts: async function getAllContactsList() {
    try {
      const { data } = await campaignsContactList.getAllContacts();
      return data;
    } catch (error) {
      throw new Error(error);
    }
}
};

export const mutations = {
  [types.SET_LIST_CONTACTS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.CLEAN_LIST_CONTACTS](state) {
    state.records = [];
  },

  [types.SET_LIST_CONTACTS]($state, data) {
    $state.records = data;
  },

  [types.SET_CAMPAIGNS_TAB]($state, data) {
    $state.tab = data;
  },
  [types.DELETE_LIST_CONTACTS]($state, listId) {
    $state.records = $state.records.filter(list => list.id !== listId);
  },

  [types.ADD_LIST_CONTACTS]($state, data) {
    $state.records.push(data);
  },
  [types.EDIT_LIST_CONTACTS](state, data) {
    const index = state.records.findIndex(activity => activity.id === data.id);
    if (index !== -1) {
      Vue.set(state.records, index, data);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
